import { Fragment, useState } from 'react';
import CourseCard from '../../shared/shared-card/CourseCard';
import { PLAN_TYPE_OPTIONS } from '../card/FeaturedCourses';
import { PLAN_TYPE } from '@lib/constants';
import { Secondary, SecondaryColor } from 'stories/Button.stories';
import DarkLayout from '@components/shared/DarkLayout';

const CourseListing = ({ courseData }) => {
  const [active, setActive] = useState('All');

  const reversedCourseList = courseData;
  const filteredData =
    active === 'All'
      ? reversedCourseList.reverse()
      : reversedCourseList.filter((item) => item.attributes.planType === active);

  return (
    <DarkLayout
      gridMode
      customStyle="!flex flex-col items-center gap-y-[72px] px-[16px] py-[40px] md:px-[124px] md:py-[80px]"
    >
      <div className="relative z-10 flex flex-col items-center gap-y-[16px] px-[16px] md:px-[240px]">
        <h1 className="text-center text-[36px] leading-tight text-white md:text-[56px]">
          Our <span className="text-red">Courses</span>
        </h1>
        <p className="text-center font-satoshi-regular text-[24px] leading-8 text-gray-2">
          Fast forward your career with our high impact, hands on and intensive courses.
        </p>
      </div>

      <div className="relative z-10 flex w-full flex-wrap items-center justify-center gap-[14px]">
        {Object.entries(PLAN_TYPE_OPTIONS).map(([key, value]) => (
          <Fragment key={key}>
            {key === active ? (
              <SecondaryColor label={value} size={'large'} />
            ) : (
              <Secondary
                customStyle={
                  '!bg-[#ffffff1a] !text-white hover:!bg-[#ffffff1a] !border-none !outline-none'
                }
                onClick={() => setActive(key)}
                label={value}
                size={'large'}
              />
            )}
          </Fragment>
        ))}
      </div>
      <div
        className={`relative z-10 grid place-items-center gap-[64px] md:grid-cols-2 md:px-[124px]`}
      >
        {filteredData.map((item, index) => (
          <CourseCard
            key={item.id}
            course={item.attributes}
            newLayout
            horizontalView={
              item.attributes.planType === PLAN_TYPE.MASTERS_DEGREE &&
              reversedCourseList.length === 3
            }
          />
        ))}
      </div>
    </DarkLayout>
  );
};

export default CourseListing;
